import { Button, IconX, csx } from '@vtex/admin-ui'
import React from 'react'

interface ClosePaymentAppIconProps {
  onClose: () => void
}

const ClosePaymentAppIcon = ({
  onClose: handleClose,
}: ClosePaymentAppIconProps) => {
  return (
    <Button
      variant="neutralTertiary"
      onClick={handleClose}
      icon={
        <IconX
          className={csx({
            width: '14px',
            height: '14px',
            color: 'black',
            borderRadius: '999px',
          })}
        />
      }
    />
  )
}

export default ClosePaymentAppIcon
